/**
 * Created by Michael on 9/24/2017.
 */
export const loadingDelay = 1500;



// WEBPACK FOOTER //
// D:/AppDev/meetup/kla-firebase-poker/web/src/settings/loading.ts